import { IfpLoansAnalyticsService } from '@sec-loans-ui/ifp-loans/analytics/service'
import { AnalyticsContextValue, NotAvailable } from '@ui-common/analytics'
import { getLanguage, getSourceChannel } from '@ui-common/utils'
import { createContext, PropsWithChildren } from 'react'

type AnalyticsContext = AnalyticsContextValue<IfpLoansAnalyticsService>

export const IfpLoansAnalyticsContext = createContext<AnalyticsContext>({
  analyticsService: new IfpLoansAnalyticsService(),
})

export const IfpLoansAnalyticsProvider = ({ children }: PropsWithChildren) => {
  return (
    <IfpLoansAnalyticsContext.Provider
      value={{
        analyticsService: new IfpLoansAnalyticsService({
          flow: NotAvailable,
          product: NotAvailable,
          src: getSourceChannel() ?? NotAvailable,
          ui_lang: getLanguage(),
          version: import.meta.env.VITE_APP_VERSION ?? NotAvailable,
        }),
      }}
    >
      {children}
    </IfpLoansAnalyticsContext.Provider>
  )
}
